import { useState, useEffect } from 'react'
import { ESortOrder } from '../components'
import { useSearchParams } from 'react-router'
import * as lib from '../lib'

export const ACCOUNT_PAGE_SORT_FIELDS = ['id', 'email', 'auth.login', 'extra.keitaroLogin', 'role.name', 'role.extra.isBuyer', 'role.extra.inGroup', 'role.extra.isTeam', 'isActive', 'isFired', 'registeredAt'] as const

export type IAccountSortField = typeof ACCOUNT_PAGE_SORT_FIELDS[number]

type IUseSortAccountPage = {
	sortBy: IAccountSortField;
	setSortBy: (value: (((prevState: IAccountSortField) => IAccountSortField) | IAccountSortField)) => void;
	order: ESortOrder;
	setOrder: (value: (((prevState: ESortOrder) => ESortOrder) | ESortOrder)) => void;
}

const DEFAULT_SORT_BY: IAccountSortField = 'id'
const DEFAULT_SORT_ORDER: ESortOrder = ESortOrder.desc
export const useSortAccountPage = (): IUseSortAccountPage => {
	const [searchParams, setSearchParams] = useSearchParams()

	const urlSort = (() => {
		try {
			return lib.sortSearchParams(searchParams.get('s')) ?? []
		} catch (error) {
			console.error(error)
			return []
		}
	})().filter((item) => {
		const sortOrderValues = Object.values(ESortOrder)

		return ACCOUNT_PAGE_SORT_FIELDS.includes(item[0] as IAccountSortField) && sortOrderValues.includes(item[1] as ESortOrder)
	})

	const [sortBy, setSortBy] = useState<IAccountSortField>(urlSort?.[0]?.[0] as IAccountSortField ?? DEFAULT_SORT_BY)
	const [order, setOrder] = useState<ESortOrder>(urlSort?.[0]?.[1] as ESortOrder ?? DEFAULT_SORT_ORDER)
	const [send, setSend] = useState<boolean>(false)
	//console.log('useSortAccountPage:: ', { sortUrl: urlSort })

	useEffect(() => {
		if (sortBy && order) {
			setSend(true)

			const newSortStr = lib.sortSetup([[sortBy, order]])

			setSearchParams((prev) => {
				if (order !== ESortOrder.unset) {
					prev.set('s', newSortStr)
				} else {
					prev.delete('s')
				}

				return prev
			})
		}
	}, [sortBy, order])

	return {
		// sort: order !== ESortOrder.unset ? [[sortBy, order]] : [],
		sortBy,
		setSortBy,
		order,
		setOrder
	}
}